import { render, staticRenderFns } from "./DeploymentNew.vue?vue&type=template&id=52e463de&"
import script from "./DeploymentNew.vue?vue&type=script&lang=js&"
export * from "./DeploymentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports